import React, { useEffect, useState, useContext } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Input } from '../../../components/forms';
import { Grid } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import Button from '../../../components/common/Button';
import { useHistory, useLocation } from 'react-router-dom';
import UsersAPI from '../user-api';
import { Skeleton } from '@material-ui/lab';
import { AppContext } from '../../../app/AppContext';
import Alert from '../../../components/common/Alert';

const ALLOWED_ROLE_TYPES = ['admin', 'comunications'];

const UserCreationContainer = () => {
  const location = useLocation();
  const history = useHistory();
  const { roles: rolesContext } = useContext(AppContext);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('admin');
  const [isLoading, setIsLoading] = useState(true);
  const [path, setPath] = useState('usuarios');
  const [showAlert, setShowAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');

  useEffect(() => {
    location.pathname.split('/')[1] === 'mentores' && setPath('mentores');
  }, [location.pathname]);

  useEffect(() => {
    const allowedRoles = Array.isArray(rolesContext.roles)
      ? rolesContext.roles.filter((rol) => ALLOWED_ROLE_TYPES.includes(rol.type))
      : [];

    setRoles(allowedRoles);
    setIsLoading(false);
  }, [rolesContext.roles]);

  useEffect(() => {
    if (
      Array.isArray(roles) &&
      roles.length > 0 &&
      !roles.some((rol) => rol.type === selectedRole)
    ) {
      setSelectedRole(roles[0].type);
    }
  }, [roles, selectedRole]);

  const addRole = (role) => {
    setSelectedRole(role);
  };

  const handleSubmit = (values) => {
    var rolSelected = roles.find((rol) => {
      return rol.type === selectedRole;
    });

    if (!rolSelected) {
      setMessageAlert('No fue posible determinar el rol seleccionado.');
      setShowAlert(true);
      return;
    }

    setShowAlert(false);

    UsersAPI.createUser({
      ...values,
      role: rolSelected.id,
    })
      .then((response) => {
        history.push({
          pathname: `/${path}`,
          state: {
            message: response.data.message,
            type: 'success',
          },
        });
      })
      .catch((e) => {
        setMessageAlert(e.data.message);
        setShowAlert(true);
      });
  };

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastNames: '',
        email: '',
        password: '',
      }}
      validationSchema={Yup.object({
        firstName: Yup.string().required('Nombre requerido.'),
        lastNames: Yup.string().required('Apellidos requeridos.'),
        email: Yup.string()
          .email('Formato de email incorrecto.')
          .required('Email requerido.'),
        password: Yup.string().required('Contraseña requerida.'),
      })}
      onSubmit={handleSubmit}
    >
      <Form>
        <Grid container className="user-container__creation user-creation">
          <Grid item xs={12} className="user-creation__alert">
            {showAlert && <Alert type="error">{messageAlert}</Alert>}
          </Grid>
          <Grid item xs={12} className="title">
            <Edit />
            <span>
              Crear {path === 'mentores' ? 'mentor' : 'usuario'} nuevo
            </span>
          </Grid>
          <Grid container className="content user-creation__layout" spacing={3}>
            <Grid item xs={12} md={4}>
              <div className="user-creation__panel user-creation__panel--roles">
                <div className="user-creation__section-header">
                  <span>
                    <strong>Seleccione un rol</strong>
                  </span>
                  <p>Define el perfil con el que se creará el usuario.</p>
                </div>

                <div className="user-creation__role-list">
                  {!isLoading ? (
                    roles &&
                    roles.map((rol) => {
                      const isActive =
                        selectedRole && selectedRole === rol.type;

                      return (
                        <div
                          className={`user-creation__role-card${
                            isActive ? ' active' : ''
                          }`}
                          key={rol.id}
                          onClick={() => {
                            addRole(rol.type);
                          }}
                        >
                      <span className="user-creation__role-label">
                            {rol.name}
                          </span>
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <Skeleton
                        variant="rect"
                        width="100%"
                        height={72}
                        className="user-creation__role-skeleton"
                      />
                      <Skeleton
                        variant="rect"
                        width="100%"
                        height={72}
                        className="user-creation__role-skeleton"
                      />
                      <Skeleton
                        variant="rect"
                        width="100%"
                        height={72}
                        className="user-creation__role-skeleton"
                      />
                    </>
                  )}
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={8}>
              <div className="user-creation__panel user-creation__panel--form">
                <div className="user-creation__section-header">
                  <span>
                    <strong>Datos personales</strong>
                  </span>
                  <p>
                    Completa la información base para crear el acceso del
                    usuario.
                  </p>
                </div>

                <Grid container spacing={2} className="user-creation__fields">
                  <Grid item xs={12} md={6}>
                    <Input name="firstName" label="Nombre" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Input name="lastNames" label="Apellidos" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Input name="email" label="Email" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Input name="password" label="Contraseña" type="password" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="user-creation__password-help">
                      <span>Políticas de contraseña</span>
                      <p>
                        De 6 a 8 caracteres, con al menos 2 letras y 2 números.
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            <Grid item xs={12}>
              <div className="submit user-creation__footer">
                <Grid
                  container
                  justify="flex-end"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item xs={12} sm={4} md={3}>
                    <Button
                      onClick={() => history.push(`/${path}`)}
                      secondary
                      widthFull
                    >
                      Cancelar
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="submit" widthFull>
                      Aceptar
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
};

export default UserCreationContainer;
